import type { JSX } from 'react';

/**
 * PST's mark: three staggered bars of a plan and one milestone - the only
 * warm colour in the interface. Drawn inline so it follows the colour scheme.
 */
export function Mark({ size = 22 }: { size?: number }): JSX.Element {
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" aria-hidden="true" style={{ display: 'block', flexShrink: 0 }}>
      <rect width="64" height="64" rx="14" fill="var(--pst-mark-ground)" />
      <rect x="12" y="16" width="26" height="7" rx="3.5" fill="var(--pst-mark-bar)" />
      <rect x="20" y="28.5" width="26" height="7" rx="3.5" fill="var(--mantine-color-brand-3)" />
      <rect x="12" y="41" width="18" height="7" rx="3.5" fill="var(--pst-mark-bar)" opacity="0.55" />
      <rect x="44" y="39" width="10" height="10" rx="1.5" transform="rotate(45 49 44)" fill="var(--pst-accent)" />
    </svg>
  );
}
